// El encabezado de la home en el TELÉFONO para la interfaz nueva (grupo C) —
// ADR-2026-10-08-la-interfaz-nueva-llega-al-telefono. Ocupa el lugar del carrusel de modos
// (`MobileModeHero`) y del hero del Agente: el saludo con la pregunta de escritorio y las
// tres cards por destino, que abren el sheet ya en su sección.

import { SaludoDeLaHome } from './SaludoDeLaHome';
import { CarruselDeDestinos } from './CarruselDeDestinos';
import { useShellMobile } from './shellMobile';
import { ListaDeHerramientas } from './SheetPorDestino';
import { CardAcademyHome } from '../../academia/CardAcademyHome';

/**
 * El color de arriba: los tintes de las tres secciones (lavanda de Redes, crema de
 * Catálogos, celeste de Anuncios) como manchas suaves, más saturadas que las cards para que
 * se lean sobre ellas. Sin esto la primera pantalla era gris y texto negro, y el color
 * aparecía recién en las cards.
 */
const FONDO =
  'radial-gradient(85% 50% at 0% 10%, #D6BDF0 0%, rgba(214,189,240,0) 72%),' +
  'radial-gradient(75% 45% at 100% 2%, #F0D9A0 0%, rgba(240,217,160,0) 72%),' +
  'radial-gradient(120% 55% at 65% 48%, #BFD0FA 0%, rgba(191,208,250,0) 74%)';

export function HomeMobilePorDestino({ nombre }: { nombre?: string | null }) {
  return (
    // `-mx-5 px-5`: el fondo mide la pantalla entera sin mover el contenido (el contenedor
    // de la home tiene sangría de 20px). SIN `overflow-x-clip`: en Safari del iPhone
    // recortaba también hacia arriba, y el fondo se cortaba en el saludo en vez de subir
    // detrás de los créditos (ADR-2026-10-18-el-fondo-de-la-home-del-telefono-no-se-recorta).
    // Nada se sale por los costados: el fondo va `inset-x-0` y el carrusel scrollea solo.
    <section className="relative isolate -mx-5 flex flex-col gap-4 px-5 pb-2 pt-1 sm:hidden">
      {/* Sube hasta el borde físico de arriba —por detrás de los créditos, que flotan— y se
          funde con el gris de la página antes de la segunda card. El `top` anula todo lo
          que hay arriba de la sección: el `mainTopPadding` de `DashboardLayout` (safe area +
          3.5rem + 0.75rem + el aviso de "generando", si está) y el `pt-4` del contenedor
          de la home. Sin el `pt-4` quedaba una franja gris arriba. */}
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 -z-10 h-[476px]"
        style={{
          top: 'calc(0px - env(safe-area-inset-top, 0px) - 5.25rem - var(--aviso-generando-mobile, 0px))',
          background: FONDO,
          WebkitMaskImage: 'linear-gradient(to bottom, #000 60%, transparent 100%)',
          maskImage: 'linear-gradient(to bottom, #000 60%, transparent 100%)',
        }}
      />
      <SaludoDeLaHome nombre={nombre} tamano="telefono" pregunta="¿Qué imágenes o videos creamos hoy?" />
      {/* Academia Atlas arriba de las cards, como en escritorio. Sin margen propio (su
          default es `mt-12`): el aire es el `gap-4` de la sección, el mismo que hay entre
          las cards; con los dos sumaba 64 px bajo el título. */}
      <CardAcademyHome className="" />
      {/* Las tres cards en carrusel (ADR-2026-10-12-los-destinos-en-carrusel-en-el-telefono). */}
      <CarruselDeDestinos />
    </section>
  );
}

/**
 * "Herramientas" en la home del teléfono (grupo C): la MISMA lista que la pestaña Herramientas
 * y que la home de escritorio, en el lugar de "Ediciones rápidas" (debajo de Creaciones
 * recientes). Antes quedaba el bloque viejo, con siete ediciones y otro dibujo.
 */
export function HerramientasMobile() {
  const { herramientas } = useShellMobile();
  if (!herramientas) return null;
  return (
    <section className="mt-8">
      <h2 className="mb-3 text-[22px] font-bold tracking-[-0.01em]">Herramientas</h2>
      <div className="-mx-3">
        <ListaDeHerramientas
          ediciones={herramientas.ediciones}
          modos={herramientas.modos}
          onElegir={(onAbrir) => onAbrir()}
        />
      </div>
    </section>
  );
}
